module.exports = __webpack_public_path__ + "static/media/diktat-15.7311c52d.mp3";